import Button from "../../../design-system/primitives/components/Button/Button";
import Text from "../../../design-system/primitives/components/Text/Text";
import primitives from "../../../design-system/primitives/primitives";
import type {
  HandbookGuide,
  HandbookModerationPlan,
} from "../../../api/handbook";
import styles from "./HandbookDocuments.css";
import ModerationPlanEntry from "./ModerationPlanEntry";

type Props = {
  guides: HandbookGuide[];
  moderationPlans: HandbookModerationPlan[];
};

const FALLBACK_COLOR = primitives.dark.purple["300"];

const HandbookDocuments = ({ guides, moderationPlans }: Props) => (
  <div className={styles.root}>
    <section className={styles.section}>
      <Text variant="subheader">Spickzettel & Anleitungen</Text>
      <div className={styles.documentGrid}>
        {guides.map((guide) => (
          <div key={guide.key} className={styles.document}>
            <div>
              <Text variant="subheader-small">{guide.title}</Text>
              {guide.description && (
                <Text color="neutral-100">{guide.description}</Text>
              )}
            </div>
            <div className={styles.documentLinks}>
              {guide.links.map((link) => (
                <Button
                  key={link.key}
                  title={link.label}
                  href={link.href}
                  target="_blank"
                  color="accent"
                  iconRight="arrow-up-right"
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>

    <section className={styles.section}>
      <div>
        <Text variant="subheader">Moderationspläne</Text>
        <Text color="neutral-100">
          Aktuell wächst hier eine Bibliothek mit Moderationsplänen zu jedem
          Spark, die du dir auch ausdrucken kannst.
        </Text>
      </div>
      <div className={styles.planGrid}>
        {moderationPlans.map((plan) => (
          <ModerationPlanEntry
            key={plan.key}
            title={plan.title}
            href={plan.href}
            color={plan.color ?? FALLBACK_COLOR}
          />
        ))}
      </div>
    </section>
  </div>
);

export default HandbookDocuments;
